<template>
  <div class="new-guide-step-1">
    <form-item label="目标事件" tips="一般为提交订单、支付订单等收益相关的事件" style="margin-top: 0">
      <div class="event-attr" :class="{ 'pb-0': localTargetEvent.conditionModels.length }">
        <t-select
          class="event-name-select"
          filterable
          placeholder="请选择"
          v-model="localTargetEvent.eventName"
          :disabled="disabled"
          @change="handleEventNameChange"
        >
          <t-option
            v-for="item in formOption.eventList"
            :key="item.id"
            :value-key="item.eventName"
            :label="item.eventShowName"
            :value="item.eventName"
          >
            {{ item.eventShowName }}
          </t-option>
        </t-select>

        <div class="connect-text">的</div>

        <event-analysis-target-column
          v-model="localTargetEvent.eventTargetColumn"
          :disabled="disabled"
          :options="formOption.targetEventColumn"
          class="event-target-column-select"
        />

        <t-button
          @click="handleAddFilterItem"
          class="btn-filter"
          variant="outline"
          :disabled="localTargetEvent.conditionModels.length >= 5"
        >
          <icon name="add" slot="icon"></icon>
          筛选项
        </t-button>
      </div>

      <template v-slot:extraLine v-if="localTargetEvent.conditionModels.length">
        <div class="filter" style="padding: 10px 0 10px 20px; background-color: #fafafa">
          <ConditionFilter
            size="medium"
            v-if="formOption.conditionOperatorOptions.length && formOption.conditionPropertyOptions.length"
            :filter-type.sync="localTargetEvent.connectors"
            :filter-list="localTargetEvent.conditionModels"
            :condition-operator-options="formOption.conditionOperatorOptions"
            :condition-property-options="formOption.conditionPropertyOptions"
            :all-event-event-property-list="allEventEventPropertyList"
            :filter-events="localTargetEvent.eventName"
          />
        </div>
      </template>
    </form-item>
  </div>
</template>

<script>
import lodash from 'lodash';
import FormItem from './form-item.vue';
import AssociateProperty from './associate-property.vue';
import ConditionFilter from '@/components/analysis/condition-filter.vue';

import { getEventList, getAllProperty, getConditionOperator, getTargetColumn } from '@/api/analysis/custom-analysis';
import EventAnalysisTargetColumn from '@/views/analysis/event-analysis/components/event-analysis-target-column.vue';

export default {
  name: 'target-event',
  components: {
    EventAnalysisTargetColumn,
    FormItem,
    ConditionFilter,
    AssociateProperty,
  },
  model: {
    prop: 'targetEvent',
    event: 'change',
  },
  props: {
    targetEvent: {
      type: Object,
      default: () => ({
        eventName: '',
        eventChineseName: '',
        eventTargetColumn: {
          type: '',
          calcType: '',
        },
        conditionModels: [],
        connectors: 'and',
      }),
    },
    eventList: {
      type: Array,
      default: () => [],
    },
    conditionPropertyOptions: {
      type: Array,
      default: () => [],
    },
    conditionOperatorOptions: {
      type: Array,
      default: () => [],
    },
    allEventEventPropertyList: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formOption: {
        eventList: [],

        targetEventColumn: [],
        targetEventColumnMap: {},

        conditionOperatorOptions: [],
        conditionPropertyOptions: [],

        preEventAttrOption: {},
      },

      localTargetEvent: lodash.cloneDeep(this.targetEvent),
    };
  },
  computed: {
    eventNameAndShowNameMap() {
      return this.formOption.eventList.reduce((total, item) => {
        total[item.eventName] = item.eventShowName;
        return total;
      }, {});
    },
  },
  created() {
    if (!this.conditionPropertyOptions) {
      getAllProperty({ params: { hasData: 1, isVisible: 1 } }).then(res => {
        this.formOption.conditionPropertyOptions = (res.list || []).map(item => ({
          propertyName: item.name,
          propertyDesc: item.chineseName,
          propertyDataType: item.javaType,
          propertyType: item.propertyType,
          name: item.name,
          propertyValueTipVOList: item.propertyValueTipVOList,
        }));
      });
    }

    if (!this.conditionOperatorOptions) {
      getConditionOperator().then(res => {
        this.formOption.conditionOperatorOptions = res;
      });
    }

    if (!this.eventList) {
      getEventList({ params: { getType: 'all' } }).then(res => {
        this.formOption.eventList = res || [];
      });
    }
  },

  watch: {
    eventList(cur) {
      this.formOption.eventList = cur;
    },
    conditionPropertyOptions(cur) {
      this.formOption.conditionPropertyOptions = cur;
    },
    conditionOperatorOptions(cur) {
      this.formOption.conditionOperatorOptions = cur;
    },
    targetEvent: {
      handler() {
        if (JSON.stringify(this.targetEvent) !== JSON.stringify(this.localTargetEvent)) {
          this.localTargetEvent = lodash.cloneDeep(this.targetEvent);
          this.setTargetEventColumn();
        }
      },
      deep: true,
    },
    localTargetEvent: {
      handler() {
        this.$emit('change', lodash.cloneDeep(this.localTargetEvent));
      },
      deep: true,
    },
  },

  methods: {
    handleEventNameChange() {
      this.localTargetEvent.eventChineseName = this.eventNameAndShowNameMap[this.localTargetEvent.eventName] || '';
      this.formOption.targetEventColumn = [];
      this.setTargetEventColumn();
    },
    handleAddFilterItem() {
      if (this.localTargetEvent.conditionModels.length >= 5) {
        this.$message.warning('最多添加5个筛选项');
        return;
      }
      this.localTargetEvent.conditionModels.push({
        column: '',
        conditionOperator: '',
        value: undefined,
      });
    },
    setTargetEventColumn() {
      const { eventName } = this.localTargetEvent;
      if (!eventName) {
        return;
      }
      const list = this.formOption.targetEventColumnMap[eventName];
      if (list) {
        this.localTargetEvent.eventTargetColumn = {
          type: list.length ? list[0].type : '',
          calcType: list.length && list[0].calcList && list[0].calcList.length ? list[0].calcList[0].calcType : '',
        };
        this.formOption.targetEventColumn = list;
        return;
      }

      getTargetColumn({ params: { events: eventName } }).then(res => {
        const list2 = res[eventName] || [];
        this.formOption.targetEventColumnMap[eventName] = list2;
        this.formOption.targetEventColumn = list2;
        this.localTargetEvent.eventTargetColumn = {
          type: list2.length ? list2[0].type : '',
          calcType: list2.length && list2[0].calcList && list2[0].calcList.length ? list2[0].calcList[0].calcType : '',
        };
      });
    },
  },
};
</script>

<style lang="less">
.modal {
  border-radius: 4px;

  .el-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
<style scoped lang="less">
@import './target-event';
</style>
